import { Theme } from '../../../config/config.types';

type HTMLElementType = any;

export type Mode = 'primary' | 'secondary' | 'normal' | 'ghost' | 'success' | 'warning' | 'error' | 'loading';
type BorderVariant = 'rectangle' | 'rounded';

export type Weight = 'thin' | 'light' | 'normal' | 'medium' | 'semibold' | 'bold';

export enum WEIGHT {
  THIN = 'thin',
  LIGHT = 'light',
  NORMAL = 'normal',
  MEDIUM = 'medium',
  SEMIBOLD = 'semibold',
  BOLD = 'bold',
}

export { Theme };
export interface StyledProps {
  mode?: Mode;
  small?: boolean;
  width?: string | number;
  borderVariant?: BorderVariant;
  weight?: Weight;
}

export interface ComponentProps extends HTMLElementType, StyledProps {}
